import type { BannerData } from '@/entities/models/page';

/**
 * Determines whether the Banner should render on the current page.
 *
 * Rules:
 * - `'default'` | `'warning'` | `'alert'` → render if content present
 * - `'disable'` | `''` | undefined | any other value → don't render
 */
export function shouldRenderBanner(banner?: Partial<BannerData>): boolean {
  if (!banner) return false;
  const layout = banner.bannerLayout;
  if (layout !== 'default' && layout !== 'warning' && layout !== 'alert') {
    return false;
  }
  return Boolean(banner.content);
}
